@if (node && workflow) {
  <div
    #nodeView
    [id]="node.id"
    [inBounds]="true"
    [style.top.px]=""
    [style.left.px]=""
    [bounds]="container"
    (movingOffset)="onMove($event)"
    (stopped)="onRelease($event)"
    [position]="{ x: xOffset, y: yOffset }"
    class="node"
    [handle]="dragHandle"
    ngDraggable
    >
    <span class="node-header">
      <div class="node-header-text text-sm w-full text-gray-500">
        {{ node.title }}
      </div>
      <div class="node-header-text text-gray-500 w-full text-xs">
        {{ node.target }}
      </div>
    </span>
    <span
      class="connector connector-left"
      (mousedown)="connectorSelected($event)"
      (mouseup)="connectorReleased($event)"
    ></span>
    <span
      class="connector connector-right"
      (mousedown)="connectorSelected($event)"
      (mouseup)="connectorReleased($event)"
    ></span>
    <div class="node-content" #dragHandle>
      <span class="node-header"> </span>
      @if (node && node.svg && node.svg.indexOf('.svg') != -1) {
        <img
          [src]="node.svg"
          class="inline node-svg"
          [alt]="node.name || 'node icon'"
        />
      }
    </div>
    <div
      class="workflow-cross"
      (click)="workflow.deleteNode(node); nodeDeleted()"
      >
      ✕
    </div>
  </div>
}
